<template>
    
    <article id="resource">
        
        <img class="res-img" v-if="resource.photo" :src="resource.photo" alt="">
        <div class="res-data">
            <h3>{{ resource.name }}</h3>
            <p style="opacity: .5;">{{ resource.resource_type_name }}</p>
            <p>Plads til {{ resource.capacity }} personer</p>
            <p>{{ resource.description}}</p>
            <p v-if="user.is_staff">{{ resource.extras }}</p>
            <p>
                Placering:<br>
                {{ resource.admin_unit_name }}<br>
                <template v-if="resource.address">
                    {{ resource.address.street }} {{ resource.address.number }} {{ resource.address.floor }} {{ resource.address.door }}<br>
                    {{ resource.address.zipcode }} {{ resource.address.town }}
                </template>
            </p>
            <p class="actions">
                <button @click="selectIt()">Reservér</button>
            </p>
        </div>
    
    </article>

</template>

<script>

    export default {
        computed: {
            resource: function() {
                return this.$store.getters.getResource
            },
            user: function() {
                return this.$store.getters.getUser
            }
        },
        watch: {
            '$route' (to, from) {
                this.fetchResource(this.$route.params.id)
            }
        },
        methods: {
            fetchResource: function(resid) {
                this.$store.dispatch('fetchResource', `/booking/room/${ resid }/`)
            },
            selectIt: function() {
                this.$emit('resource-pick', this.resource)
                this.$router.push('/search/bookingform')
            }
        },
        created: function() {
            this.fetchResource(this.$route.params.id)
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #resource {
        padding: 1rem;

        img {
            max-width: 100%;
        }
        .actions {
            text-align: right;

            button {
                margin: 0;
            }
        }
        
    }

    @media screen and (min-width: $wide) {

        #resource {
            max-width: 70rem;
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-start;

            .res-img {
                flex: 1 0 50%;
                height: auto;
                margin-right: 2rem; 
            }
            .res-data {
                flex: 0 1 50%;
                max-width: 40rem;
            }
        }

    }

</style>
